import { Component,EventEmitter,Inject,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { CreditCardFilterFormHelper,CreditCardFilterFormState} from './credit-card-filter-form.helper';
import { BaseFpxFormComponent,CriteriaQuery,ValidatorService } from '@fpx/core';
// import { CasatransactionfilterService } from './casatransactionfilter.service';
import { CreditCardfilterService } from './credit-card-filter.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/common.service';
import { FileOpenerService } from 'src/app/services/mobile/file-opener.service';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { ResponsiveService } from 'src/app/responsive.service';
// import { CasatransactionfilterService } from '../casatransactionfilter-service/casatransactionfilter.service';
// import { Casatransactionfilter } from '../casatransactionfilter-service/casatransactionfilter.model';


@Component({
  selector: 'app-credit-card-filter',
  templateUrl: './credit-card-filter.component.html',
  styleUrls: ['./credit-card-filter.component.scss']
})

export class CreditCardFilterComponent extends BaseFpxFormComponent<CreditCardFilterFormHelper, CreditCardFilterFormState> {
  accountNumber: any;
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public creditCardFilterFormHelper: CreditCardFilterFormHelper,
    public creditCardfilterService: CreditCardfilterService,
    private validatorService: ValidatorService,
    private _commonService : CommonService,
    protected _responsive:ResponsiveService,
    private _fileOpner: FileOpenerService,
    private _matDialogRef: MatDialogRef<CreditCardFilterComponent>,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData

  ) {
    super(formBuilder, router,controlContainer, creditCardFilterFormHelper);
  }



 protected override doPreInit(): void {
   this.addFormControl('transactionPeriod', '', []    ,[],'change' );
   
   this.addFormControl('period', '', []    ,[],'change' );

   this.addFormControl('displayDownloadFormat', '', []    ,[],'change' );
	this.setDataService(this.creditCardfilterService);

  this.accountNumber=this.data?.screenData.data

  console.log("accountNumberCasa",this.accountNumber);
  }
  // submitForm() {
  //   let payload = this._helper.preSubmitInterceptor(this.formGroup.value);
  //   let displayDownloadFormat = this.formGroup.get('displayDownloadFormat').value;

  //   if(payload.fileType=='PDF'){

  //     this.casatransactionfilterService.createFilter(payload).subscribe(x=>{})
  //     this._matDialogRef.close();
  //   }else{
  //     const criteria:CriteriaQuery = new CriteriaQuery();
  //     criteria.addQueryparam('fromDate',payload.fromDate)
  //     criteria.addQueryparam('toDate',payload.toDate)
  //     criteria.addQueryparam('accountNumber',payload.accountNumber)
  //     criteria.addQueryparam('fileType','VOS')
  //       criteria.addQueryparam('transactionPeriod',payload.transactionPeriod)


  //     this._matDialogRef.close(criteria);
  //  }
  // }
//   submitForm() {
//   let cardRefNum: any;
// cardRefNum = this.accountNumber;
// this.casatransactionfilterService.downloadAccountStatements(cardRefNum).subscribe({
//   next: (response: any) => {
//     this._commonService.hideSpinner();
//     if (this._commonService.isHybrid()) {
//       this._fileOpner.openPDF(
//         response,
//         "application/pdf",
//         "TransactionDetails.pdf"
//       );
//     } else {
//       let documentURL = URL.createObjectURL(
//         new Blob([response.body], { type: "application/pdf" })
//       );
//       const downloadLink = document.createElement("a");
//       downloadLink.href = documentURL;
//       const fileName = "TransactionDetails";
//       downloadLink.download = fileName;
//       downloadLink.click();
//     }
//   },
// });
// }


}
